/**
 * 提现状态
 */
export const drawMoneyStatusMapArr = [
  { key: '', value: '全部' },
  { key: 0, value: '提现失败', badge: 'error' },
  { key: 1, value: '提现成功', badge: 'success' },
  { key: 2, value: '取消', badge: 'default' },
  { key: 3, value: '提现中', badge: 'processing' },
  { key: 4, value: '提交至银行', badge: 'processing' },
  { key: 5, value: '审核中', badge: 'processing' },
];

/**
 * 收费项目状态
 */
export const chargeItemStatusMapArr = [
  { key: '', value: '全部' },
  { key: 'ERROR', value: '错误', badge: 'error' },
  { key: 'NOT_START', value: '未开始', badge: 'default' },
  { key: 'IN_PROCESS', value: '进行中', badge: 'processing' },
  { key: 'END', value: '到期', badge: 'warning' },
];

/**
 * 支付状态
 */
export const payStatusMapArr = [
  { key: '', value: '全部' },
  { key: 'PAYING', value: '等待支付' },
  { key: 'PAY_SUCCESS', value: '支付成功' },
  { key: 'PAY_FAILED', value: '支付失败' },
  { key: 'REFUNDING', value: '退款中' },
  { key: 'REFUND', value: '退款成功' },
  { key: 'CANCEL', value: '取消订单/取消支付' },
  { key: 'REFUND_PART', value: '部分退款' },
  { key: 'EXPIRE', value: '过期' },
  { key: 'NOT_START', value: '未开始' },
  { key: 'NOT_PARTICIPATE', value: '不参与' },
  { key: 'NOT_PARTICIPATE_EXPIRE', value: '不参与且已过期' },
];

/**
 * 费用类型
 */
export const costTypeMapArr = [
  { key: '', value: '全部' },
  { key: 1, value: '收入', badge: 'processing' },
  { key: 0, value: '提现', badge: 'success' },
  { key: 2, value: '提现失败', badge: 'error' },
  { key: 3, value: '退款', badge: 'default' },
];

/**
 * 收费方式
 */
export const chargeItemModeMapArr = [
  { key: '', value: '全部' },
  { key: 'SCAN', value: '扫码收费' },
  { key: 'NOTIFICATION', value: '通知收费' },
];

/**
 * 商品状态
 */
export const commodityStatusMapArr = [
  { key: 'ON_SHELF', value: '已上架', badge: 'processing' },
  { key: 'OFF_SHELF', value: '已下架', badge: 'error' },
  { key: 'NOT_SHELF', value: '未上架', badge: 'warning' },
];

/**
 * 分组状态
 */
export const groupTypeMapArr = [
  { key: 'SCHOOL_WORKER_GROUP', value: '教职工组' },
  { key: 'STUDENT_GROUP', value: '学生组' },
];

/**
 * 支付方式
 */
export const payMethodMapArr = [
  { key: '', value: '全部' },
  { key: 'ALI_PAY', value: '支付宝支付' },
  { key: 'WX_APY', value: '微信支付' },
  { key: 'CASH_PAY', value: '现金支付' },
];



// WEBPACK FOOTER //
// ./src/utils/enum/state-enum.js